import React from 'react';
import { Lightbulb, Rocket, TrendingUp } from 'lucide-react';
import { content } from '../data/content';

const HowItWorks = () => {
  const icons = [Lightbulb, Rocket, TrendingUp];

  return (
    <section className="py-32 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-24">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-50 mb-8">
            {content.howItWorks.title}
          </h2>
          <p className="text-xl text-amber-100/60 max-w-4xl mx-auto font-light leading-relaxed">
            {content.howItWorks.subtitle}
          </p>
          <div className="w-24 h-1 bg-amber-500/40 mx-auto mt-8"></div>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-12 lg:gap-16">
          {content.howItWorks.steps.map((step, index) => {
            const IconComponent = icons[index];
            return (
              <div key={index} className="relative">
                {/* Connector Line (hidden on last item) */}
                {index < content.howItWorks.steps.length - 1 && (
                  <div className="hidden md:block absolute top-20 left-1/2 w-full h-0.5 bg-gradient-to-r from-amber-500/30 to-amber-500/10 z-0"></div>
                )}

                <div className="relative z-10 text-center">
                  {/* Number & Icon */}
                  <div className="mb-8 flex flex-col items-center">
                    <div className="relative inline-block mb-4">
                      <div className="absolute inset-0 bg-amber-500/20 blur-2xl rounded-full"></div>
                      <div className="relative bg-gradient-to-br from-amber-500/20 to-amber-600/10 border border-amber-500/30 rounded-2xl p-6">
                        <IconComponent className="w-12 h-12 text-amber-400" />
                      </div>
                    </div>
                    <span className="text-6xl font-bold text-amber-500/20 tracking-tighter">
                      {step.number}
                    </span>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-amber-50 mb-4">
                    {step.title}
                  </h3>
                  <p className="text-amber-100/60 leading-relaxed font-light">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
